import React, { useState, useEffect } from 'react';

const ReadingProgressBar = ({ post }) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
      
      setProgress(Math.min(scrollPercent, 100));
      setIsVisible(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div
      className="fixed top-0 left-0 w-full z-50 bg-[#f5f4f2]/90 backdrop-blur-sm border-b border-stone-200"
    >
      <div className="max-w-4xl mx-auto px-6 py-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex flex-col">
              <span className="text-sm font-medium text-[#2d2b29]">
                {Math.round(progress)}% read
              </span>
              <span className="text-xs text-[#7b7671] uppercase tracking-[0.2em]">
                {post?.estimatedReadTime || '5 min read'}
              </span>
            </div>
          </div>
          
          <div className="flex items-center space-x-2">
            <div className="w-32 bg-[#e4e2de] rounded-full h-2">
              <div
                className="h-2 rounded-full bg-[#2d2b29]"
                style={{ width: `${progress}%` }}
              />
            </div>
            <span className="text-xs text-[#7b7671] font-medium">
              {Math.round(progress)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadingProgressBar; 
